module.exports = __webpack_public_path__ + "static/media/equalizer.c564da32.svg";